import { FC } from 'react';
import { makeStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles';

import BeginnerImg from '../images/class-images/beginner.png';
import WarriorImg from '../images/class-images/warrior.png';
import MagicianImg from '../images/class-images/magician.png';
import ArcherImg from '../images/class-images/archer.png';
import PathfinderImg from '../images/class-images/pathfinder.png';
import ThiefImg from '../images/class-images/thief.png';
import DualBladeImg from '../images/class-images/dualblade.png';
import PirateImg from '../images/class-images/pirate.png';
import JettImg from '../images/class-images/jett.png';
import DawnWarriorImg from '../images/class-images/dawnwarrior.png';
import BlazeWizardImg from '../images/class-images/blazewizard.png';
import WindArcherImg from '../images/class-images/windarcher.png';
import NightWalkerImg from '../images/class-images/nightwalker.png';
import ThunderBreakerImg from '../images/class-images/thunderbreaker.png';
import AranImg from '../images/class-images/aran.png';
import EvanImg from '../images/class-images/evan.png';
import MercedesImg from '../images/class-images/mercedes.png';
import PhantomImg from '../images/class-images/phantom.png';
import LuminousImg from '../images/class-images/luminous.png';
import ShadeImg from '../images/class-images/shade.png';
import DemonSlayerImg from '../images/class-images/demonslayer.png';
import DemonAvengerImg from '../images/class-images/demonavenger.png';
import BattleMageImg from '../images/class-images/battlemage.png';
import WildHunterImg from '../images/class-images/wildhunter.png';
import MechanicImg from '../images/class-images/mechanic.png';
import XenonImg from '../images/class-images/xenon.png';
import BlasterImg from '../images/class-images/blaster.png';
import KaiserImg from '../images/class-images/kaiser.png';
import KainImg from '../images/class-images/kain.png';
import CadenaImg from '../images/class-images/cadena.png';
import AngelicBusterImg from '../images/class-images/angelicbuster.png';
import AdeleImg from '../images/class-images/adele.png';
import IlliumImg from '../images/class-images/illium.png';
import KhaliImg from '../images/class-images/khali.webp';
import ArkImg from '../images/class-images/ark.png';
import KannaImg from '../images/class-images/kanna.png';
import HayatoImg from '../images/class-images/hayato.png';
import KinesisImg from '../images/class-images/kinesis.png';
import BeastTamerImg from '../images/class-images/beasttamer.png';
import ZeroImg from '../images/class-images/zero.png';
import HoyoungImg from '../images/class-images/hoyoung.png';
import LaraImg from '../images/class-images/lara.png';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        imageContainer: {
            position: 'relative',
            width: "100%",
            height: "100%",
        },
        imageClass: {
            position: 'absolute',
            left: 0,
            top: 0,
            height: '100%',
            width: '100%',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            filter: 'grayscale(80%) contrast(70%) brightness(40%)',
            opacity: 0.6,
        },
        imageAvatar: {
            position: 'absolute',
            left: 'calc(50% - 72px)',
            top: 'calc(50% - 72px)',
        },
        imgChar: {
            height: 144,
            width: 144,
        }
    })
);

interface CharacterHeroImageProps {
    charAvatar: string;
    charClass: string;
    charName: string;
}

const CharacterHeroImage: FC<CharacterHeroImageProps> = (props: CharacterHeroImageProps) => {
    const classes = useStyles();
    let classImg = BeginnerImg;
    const classImgKey = props.charClass.toLowerCase().replace(" ", "").replace("-", "").replace("/", "");
    switch (classImgKey) {
        case "beginner":
        case "legend":
        case "citizen":
            classImg = BeginnerImg; break;
        case "warrior":
        case "fighter":
        case "crusader":
        case "hero":
        case "page":
        case "whiteknight":
        case "paladin":
        case "spearman":
        case "berserker":
        case "darkknight":
            classImg = WarriorImg; break;
        case "magician":
        case "mage":
        case "firepoisonwizard":
        case "firepoisonmage":
        case "firepoisonarchmage":
        case "icelightningwizard":
        case "icelightningmage":
        case "icelightningarchmage":
        case "cleric":
        case "priest":
        case "bishop":
            classImg = MagicianImg; break;
        case "archer":
        case "bowman":
        case "hunter":
        case "ranger":
        case "bowmaster":
        case "crossbowman":
        case "sniper":
        case "marksman":
            classImg = ArcherImg; break;
        case "pathfinder":
        case "archerpathfinder":
        case "ancientarcher":
        case "soulchaser":
            classImg = PathfinderImg; break;
        case "thief":
        case "assassin":
        case "hermit":
        case "nightlord":
        case "bandit":
        case "chiefbandit":
        case "shadower":
            classImg = ThiefImg; break;
        case "dualblade":
        case "bladerecruit":
        case "bladeacolyte":
        case "bladespecialist":
        case "bladelord":
        case "blademaster":
            classImg = DualBladeImg; break;
        case "pirate":
        case "brawler":
        case "marauder":
        case "buccaneer":
        case "gunslinger":
        case "outlaw":
        case "corsair":
        case "cannoneer":
        case "cannonblaster":
        case "cannonmaster":
            classImg = PirateImg; break;
        case "jett": classImg = JettImg; break;
        case "dawnwarrior": classImg = DawnWarriorImg; break;
        case "blazewizard": classImg = BlazeWizardImg; break;
        case "windarcher": classImg = WindArcherImg; break;
        case "nightwalker": classImg = NightWalkerImg; break;
        case "thunderbreaker": classImg = ThunderBreakerImg; break;
        case "aran": classImg = AranImg; break;
        case "evan": classImg = EvanImg; break;
        case "mercedes": classImg = MercedesImg; break;
        case "phantom": classImg = PhantomImg; break;
        case "luminous": classImg = LuminousImg; break;
        case "shade": classImg = ShadeImg; break;
        case "demonslayer": classImg = DemonSlayerImg; break;
        case "demonavenger": classImg = DemonAvengerImg; break;
        case "battlemage": classImg = BattleMageImg; break;
        case "wildhunter": classImg = WildHunterImg; break;
        case "mechanic": classImg = MechanicImg; break;
        case "xenon": classImg = XenonImg; break;
        case "blaster": classImg = BlasterImg; break;
        case "kaiser": classImg = KaiserImg; break;
        case "kain": classImg = KainImg; break;
        case "cadena": classImg = CadenaImg; break;
        case "angelicbuster": classImg = AngelicBusterImg; break;
        case "adele": classImg = AdeleImg; break;
        case "illium": classImg = IlliumImg; break;
        case "khali": classImg = KhaliImg; break;
        case "ark": classImg = ArkImg; break;
        case "kanna": classImg = KannaImg; break;
        case "hayato": classImg = HayatoImg; break;
        case "kinesis": classImg = KinesisImg; break;
        case "beasttamer": classImg = BeastTamerImg; break;
        case "zero": classImg = ZeroImg; break;
        case "hoyoung": classImg = HoyoungImg; break;
        case "lara": classImg = LaraImg; break;
        default: classImg = BeginnerImg; break;
    }

    return (
        <div className={classes.imageContainer}>
            <div className={classes.imageClass} style={{ backgroundImage: `url(${classImg})` }}>
            </div>
            <div className={classes.imageAvatar}>
                <img className={classes.imgChar} alt={`${props.charName} character avatar`} src={props.charAvatar} />
            </div>
        </div>
    )
}

export default CharacterHeroImage;
